import { render, staticRenderFns } from "./StatusBemIcon.vue?vue&type=template&id=ae83d13a&scoped=true"
import script from "./StatusBemIcon.vue?vue&type=script&lang=js"
export * from "./StatusBemIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae83d13a",
  null
  
)

export default component.exports